import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';

import { SUCCESS_MODAL_TITLE, SUCCESS_MODAL_TEXT, CLOSE_BUTTON_LABEL } from './constants';

export function ContactSellerModalContent({ onToggle = noop }) {
  return (
    <div className="d-flex flex-column align-items-center gap-1_5 pt-1">
      <div className="d-flex flex-column align-items-center gap-0_5 py-1 text-center">
        <h3 className="size-24 fw-medium text-cool-gray-30 mb-0">{SUCCESS_MODAL_TITLE}</h3>
        <p className="size-16 text-cool-gray-30 mb-0">{SUCCESS_MODAL_TEXT}</p>
      </div>
      <button
        type="button"
        className="contact-seller-modal-close-link btn btn-link p-0 size-14 text-cool-gray-30 text-underline text-transform-none fw-normal"
        onClick={onToggle}
      >
        {CLOSE_BUTTON_LABEL}
      </button>
    </div>
  );
}

ContactSellerModalContent.propTypes = {
  onToggle: PropTypes.func,
};
